import type { LiteralValues } from '@/utils/typing/literal-values.type';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { EllipsisWithTitleFallbackDirective } from '../../directives/ellipsis-with-title-fallback/ellipsis-with-title-fallback.directive';

export const ProgressMode = {
    PERCENTAGE: 'percentage',
    ABSOLUTE: 'absolute'
} as const;

export type ProgressMode = LiteralValues<typeof ProgressMode>;

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./progress-bar.scss'],
    selector: 'progress-bar',
    templateUrl: 'progress-bar.html',
    imports: [EllipsisWithTitleFallbackDirective]
})
export class ProgressBarComponent {
    progressType = input<ProgressMode>(ProgressMode.PERCENTAGE);
    progress = input.required<number>();
    name = input('');
    current = input('');
    maximum = input('');
    color = input('');
}
